import {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import {Col, Container, Row} from 'components/elements/grid'
import HowItem from 'components/elements/HowItem/HowItem'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2HowItWorks.module.scss'
const cx = cn.bind(s)

interface IW2HowItWorksProps {
	className?: string
	content: IW2Content['howItWorks']
}

/** W2HowItWorks block component */
const W2HowItWorks: FC<IW2HowItWorksProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />

				<Row>
					<Col>
						<div className={cx('list')}>
							{content?.items?.map((item, index) => (
								<HowItem
									className={cx('list__item')}
									key={item._key}
									step={index + 1}
									title={item.title || ''}
									description={item.description || ''}
								/>
							))}
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

W2HowItWorks.displayName = 'W2HowItWorks'

export default W2HowItWorks
